import Column from "@components/column";
import CategoryForm from "./form";
import CategoryList from "./list";

const Category = () => {
  return (
    <Column>
      <CategoryForm />
      <CategoryList />
    </Column>
  );
};

export default Category;
